export const activeInstances = new Set();

export const css = new Map();

export const springs = new Map();

export const ON_DOCUMENT_VISIBILITY = Symbol('ON_DOCUMENT_VISIBILITY');